import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { AppHeader, ContentNeck, useTranslator } from "@sia/style-guide";
import GlobalContext from "contexts/GlobalContext";

const Page = (props) => {
  const translate = useTranslator();
  const { user } = useContext(GlobalContext);
  const createBrowserTitle = () => {
    const browserTitle = translate("browser.title");
    if (props.title) {
      const pageTitle = translate(props.title);
      return `${pageTitle} - ${browserTitle}`;
    }
    return browserTitle;
  };

  useEffect(() => {
    document.title = createBrowserTitle();
  });

  const renderAppHeader = () => {
    let lang = window.location.pathname.split("/")[1];
    let currentUrlPart = window.location.pathname.split("/")[2];
    const appHeaders = [
      {
        name: "SIA-Account",
        urlPart: "account",
        link: `/${lang}/account/customer-data`,
      },
      {
        name: "SIA-Reference-gallery",
        urlPart: "reference-gallery",
        link: `/${lang}/reference-gallery/search`,
      },
      { name: "SIA-Jobs", urlPart: "jobs", link: `/${lang}/jobs/offers` },
      {
        name: "SIA-Directory",
        urlPart: "directory",
        link: `/${lang}/directory?sort=1`,
      },
      { name: "SIA-Wizard", urlPart: "wizard", link: `/${lang}/wizard` },
      { name: "SIA-Agenda", urlPart: "agenda", link: `/${lang}/agenda` },
      { name: "Value-App", urlPart: "value-app", link: `/${lang}/value-app` },
    ];
    const appHeader = appHeaders.find((appHeader) => appHeader.urlPart === currentUrlPart);
    if (appHeader) {
      if (appHeader.name === "account" && user) {
        const info = [user.siaId, user.originalMemberType];
        return <AppHeader appName={appHeader.name} translate={translate} info={info} link={appHeader.link} />;
      }
      return <AppHeader appName={appHeader.name} translate={translate} link={appHeader.link} />;
    }
  };
  return (
    <div id={"page"} className={props.className}>
      <ContentNeck>
        {renderAppHeader()}
        {props.contentNavigation}
      </ContentNeck>

      {props.children}
    </div>
  );
};
Page.propTypes = {
  contentNavigation: PropTypes.object,
  title: PropTypes.string,
  className: PropTypes.string,
};
export default Page;
